"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.chat-thread-sharing.disabled': 'La función de compartir hilos de chat no está disponible en su plan actual.',
};
